/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const questionAccordion = () => {
  const questionButtons = document.querySelectorAll('.shoppingguide-questionBt')

  questionButtons.forEach((item) => {
    item.addEventListener(
      'click',
      function () {
        const currentSelected = item.getAttribute('aria-selected')
        const nextObj = item.parentNode.nextElementSibling
        const nextObjChild = nextObj.getElementsByClassName('shoppingguide-answerInner')
        const nextObjH = nextObjChild[0].clientHeight

        if (currentSelected === 'true') {
          setTimeout(function () {
            item.setAttribute('aria-selected', 'false')
            nextObj.setAttribute('aria-hidden', 'true')
            nextObj.style.height = '0px'
          }, 100)
        } else {
          item.setAttribute('aria-selected', 'true')
          nextObj.setAttribute('aria-hidden', 'false')
          nextObj.style.height = nextObjH + 'px'
        }
      },
      false
    )
  })
  /**
   * Windowリサイズ時
   * コンテンツの高さに合わせてアコーディオンを広げる
   */
  const resetH = () => {
    const answerBox = document.querySelectorAll('.shoppingguide-answer')
    answerBox.forEach((item) => {
      if (item.clientHeight > 0) {
        const childObj = item.getElementsByClassName('shoppingguide-answerInner')
        const childH = childObj[0].clientHeight
        item.style.height = childH + 'px'
      }
    })
  }
  window.addEventListener('resize', resetH)
}

window.addEventListener('DOMContentLoaded', (event) => {
  questionAccordion()
})